import React from "react";
import { useParams } from "react-router-dom";

import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/laufen/bg_sport.png"; 

import herzlogoImg from "../../images/laufen/kl_Herzlogo.jpg";

import herzlaufImg2025 from "../../images/laufen/Herzlauf_2025-gr.jpg";
import vcm2025 from "../../images/laufen/Slider_VCM_2025_gr.jpg";

import venedigImg from "../../images/laufen/Venedig_2024.jpg";
import herzlaufImg2024 from "../../images/laufen/herzlauf_2024.jpg";
import vcm2024 from "../../images/laufen/VCM_2024_1.jpg";

import venedigImg2023 from "../../images/laufen/laufen_venedig_2023.jpg";
import herzlauf2023Img1 from "../../images/laufen/Herzlauf_2023-1.jpg";
import herzlauf2023Img2 from "../../images/laufen/Herzlauf_2023-2.jpg";

import venedig2022Img from "../../images/laufen/Venedig_2022.jpg";
import frauenlauf2022Img from "../../images/laufen/laufen_frauenlauf_2022-1.jpg";
import herzlauf2022Img1 from "../../images/laufen/laufen_herzlauf_2022-1.jpg";
import herzlauf2022Img2 from "../../images/laufen/laufen_herzlauf_2022-2.jpg";
import herzlauf2022Img3 from "../../images/laufen/laufen_herzlauf_2022-3.jpg";
import herzlauf2022Img4 from "../../images/laufen/laufen_herzlauf_2022-4.jpg";
import marathon2022Img1 from "../../images/laufen/laufen_marathon_2022.jpg";
import marathon2022Img2 from "../../images/laufen/laufen_marathon_2022-2.jpg";

import marathon2021Img from "../../images/laufen/Marathon_2021.jpg";
import frauenlauf2021Img from "../../images/laufen/Frauenlauf_2021-1.jpg";

import frauenlauf2018_1 from "../../images/laufen/Frauenlauf_2018-1.jpg";
import frauenlauf2018_2 from "../../images/laufen/Frauenlauf_2018-2.jpg";
import frauenlauf2018_3 from "../../images/laufen/Frauenlauf_2018-3.jpg";
import frauenlauf2018_4 from "../../images/laufen/Frauenlauf_2018-4.jpg";
import frauenlauf2018_5 from "../../images/laufen/Frauenlauf_2018-5.jpg";

import frauenlauf2017_1 from "../../images/laufen/Frauenlauf_2017-1.jpg";
import frauenlauf2017_2 from "../../images/laufen/Frauenlauf_2017-2.jpg";
import frauenlauf2017_3 from "../../images/laufen/Frauenlauf_2017-3.jpg";
import frauenlauf2017_4 from "../../images/laufen/Frauenlauf_2017-4.jpg";
import frauenlauf2017_5 from "../../images/laufen/Frauenlauf_2017-5.jpg";
import frauenlauf2017_6 from "../../images/laufen/Frauenlauf_2017-6.jpg";

import Venedig2025_1 from "../../images/laufen/Venedig_2025-1.jpeg";
import Venedig2025_2 from "../../images/laufen/Venedig_2025-2.jpeg";
import Venedig2025_3 from "../../images/laufen/Venedig_2025-3.jpeg";

import VCM_2026_1 from "../../images/laufen/VCM2026_1.jpeg";
import VCM_2026_2 from "../../images/laufen/VCM2026_2.jpeg";
import VCM_2026_3 from "../../images/laufen/VCM2026_3.jpeg";
import VCM_2026_4 from "../../images/laufen/VCM2026_4.jpeg";

import Lauf_2026_1 from "../../images/laufen/8EA93D46-F4F7-4B72-8DF7-1D2A5A5E6F7E.jpeg"
import Lauf_2026_2 from "../../images/laufen/852bc143-cf98-4b4a-8b4f-cecf2f0fb41b.jpg"
import Lauf_2026_3 from "../../images/laufen/870050ee-4398-4c11-9ae7-9d58f490e150.jpg"
import Lauf_2026_4 from "../../images/laufen/IMG_0937.jpeg"
import Lauf_2026_5 from "../../images/laufen/IMG_0939.jpeg"




const Years = [
    <div className="page-container">
            <h1>Kurse – Herzdoktor Laufteam</h1>

            <p className="page-text">
                <b><i>Wie langsam Du auch läufst – Du schlägst alle, die zu Hause bleiben!</i></b>
                <br /><br />
            </p>
            <img
                src={herzlogoImg}
                alt="Herzdoktor Logo"
                className="sujet_rechts"
                style={{ maxWidth: "300px", height: "auto", float:"right" }}
            />

            <p className="page-text">
                Frische Bewegungsgrüße schickt allen<br />
                Ihre Claudia Sebald und Team!
            </p>

            <p className="page-text">
                <b> 2026! </b>
                <br /> 
                VCM 2026 - Wir haben es wieder getan! 1x VM, 1x HM , 2 Staffeln erfolgreich geschlagen
                <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                    <img
                        src={Lauf_2026_1}
                        alt="VCM 2026"
                        style={{ maxWidth: "80%", height: "auto" }}
                    />
                </div>
                <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                    <img
                        src={Lauf_2026_2}
                        alt="VCM 2026"
                        style={{ maxWidth: "80%", height: "auto" }}
                    />
                </div>
                <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                    <img
                        src={Lauf_2026_3}
                        alt="VCM 2026"
                        style={{ maxWidth: "80%", height: "auto" }}
                    />
                </div>
                <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                    <img
                        src={Lauf_2026_4}
                        alt="VCM 2026"
                        style={{ maxWidth: "80%", height: "auto" }}
                    />
                </div>
                <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                    <img
                        src={Lauf_2026_5}
                        alt="VCM 2026"
                        style={{ maxWidth: "80%", height: "auto" }}
                    />
                </div>


                <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                    <img
                        src={VCM_2026_1}
                        alt="VCM 2026"
                        style={{ maxWidth: "80%", height: "auto" }}
                    />
                </div>
                <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                    <img
                        src={VCM_2026_2}
                        alt="VCM 2026"
                        style={{ maxWidth: "80%", height: "auto" }}
                    />
                </div>
                <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                    <img
                        src={VCM_2026_3}
                        alt="VCM 2026"
                        style={{ maxWidth: "80%", height: "auto" }}
                    />
                </div>
                <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                    <img
                        src={VCM_2026_4}
                        alt="VCM 2026"
                        style={{ maxWidth: "80%", height: "auto" }}
                    />
                </div>
            </p>



            <p className="page-text">
                <b>26.10.25 Venedig Lauf </b>
                <br/>
                26.10.25 Venedig Lauf 10 km und HM ist vollbracht! Herrliches Wetter , beste Laufbedinungen für das Herzdoktorteam.
            </p>
            <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                <img
                    src={Venedig2025_1}
                    alt="Venedig 2025"
                    style={{ maxWidth: "80%", height: "auto" }}
                />
            </div>
            <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                <img
                    src={Venedig2025_2}
                    alt="Venedig 2025"
                    style={{ maxWidth: "80%", height: "auto" }}
                />
            </div>
            <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                <img
                    src={Venedig2025_3}
                    alt="Venedig 2025"
                    style={{ maxWidth: "80%", height: "auto" }}
                />
            </div>
        </div>,

    
        <div className="page-container">
            <h1>Kurse – Herzdoktor Laufteam</h1>
            <p className="page-text">
                <b>08.05.2025 – Herzlauf Wien</b>
            </p>

            <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                <img
                    src={herzlaufImg2025}
                    alt="Herzlauf 2025"
                    style={{ maxWidth: "100%", height: "auto" }}
                />
            </div>

            <p className="page-text">
                <b>06.04.2025 – Vienna City Marathon 2025</b>
                <br /><br />
                Es ist vollbracht!<br />
                Herzdoktor und drei weitere Ordinationen haben bei eiskalten Temperaturen mit Team Aorta, Team Brain und Team Gastro – 3 Staffeln und zwei Halbmarathon – absolviert!<br />
                KollegInnen, Mitarbeiter, PatientInnen und deren Familien waren dabei.<br />
                Wieder einmal ein tolles Erlebnis!<br />
                Nach dem Lauf ist vor dem Lauf, aber heute bekommen unsere Muskeln Ruhe …
            </p>

            <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                <img
                    src={vcm2025}
                    alt="Vienna City Marathon 2025"
                    style={{ maxWidth: "100%", height: "auto" }}
                />
            </div>
        </div>,
        
        <div className="page-container">
        <h1>Kurse – Herzdoktor Laufteam</h1>

        <p className="page-text"><b>27.10.2024 – Venedig Marathon</b></p>
        <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
            <img
                src={venedigImg}
                alt="Venedig Marathon 2024"
                style={{ maxWidth: "100%", height: "auto" }}
            />
        </div>

        <p className="page-text"><b>07.05.2024 – Herzlauf</b></p>
        <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
            <img
                src={herzlaufImg2024}
                alt="Herzlauf 2024"
                style={{ maxWidth: "100%", height: "auto" }}
            />
        </div>

        <p className="page-text">
            <b>„VCM 2024“ – Es ist vollbracht!</b><br /><br />
            12 SportlerInnen haben drei Staffeln und einen Halbmarathon absolviert!<br />
            Ein tolles „Herz-HirnTeam“ (Ordination Dr. Funk)<br /><br />
            Wir danken allen, die uns emotional unterstützt und mitgefiebert haben!
        </p>

        <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
            <img
                src={vcm2024}
                alt="VCM 2024"
                style={{ maxWidth: "100%", height: "auto" }}
            />
        </div>

        <img
            src={herzlogoImg}
            alt="Herzdoktor Logo"
            className="sujet_rechts"
            style={{ maxWidth: "300px", height: "auto", float: "right" }}
        />

        <p className="page-text">
            Frische Bewegungsgrüße schickt allen<br />
            Ihre Claudia Sebald und Team!
        </p>
    </div>,

    <div className="page-container">
        <h1>Kurse – Herzdoktor Laufteam</h1>

        <p className="page-text">
            <b><i>Wie langsam Du auch läufst – Du schlägst alle, die zu Hause bleiben!</i></b>
        </p>

        <img
            src={herzlogoImg}
            alt="Herzdoktor Logo"
            className="sujet_rechts"
            style={{ maxWidth: "300px", height: "auto", float: "right" }}
        />

        <p className="page-text"><b>Venedig Marathon 2023</b></p>
        <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
            <img
                src={venedigImg2023}
                alt="Venedig Marathon 2023"
                style={{ maxWidth: "100%", height: "auto" }}
            />
        </div>

        <p className="page-text"><b>Herzlauf vollbracht!</b></p>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", margin: "20px 0" }}>
            <img
                src={herzlauf2023Img1}
                alt="Herzlauf 2023 - Bild 1"
                style={{ maxWidth: "100%", height: "auto" }}
            />
            <img
                src={herzlauf2023Img2}
                alt="Herzlauf 2023 - Bild 2"
                style={{ maxWidth: "100%", height: "auto" }}
            />
        </div>

        <p className="page-text">
            Frische Bewegungsgrüße schickt allen<br />
            Ihre Claudia Sebald und Team!
        </p>
    </div>,

    <div className="page-container">
        <h1>Kurse – Herzdoktor Laufteam</h1>

        <p className="page-text"><b>Venedig Marathon 2022</b></p>
        <p className="page-text">
            Als begeisterter Venedigfan haben mich besonders engagierte Patienten auf den Venedigmarathon aufmerksam gemacht und somit ist die Entscheidung gefallen.<br />
            Das Herzdoktoteam startet in der Serenissima!
        </p>
        <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
            <img
                src={venedig2022Img}
                alt="Venedig Marathon 2022"
                style={{ maxWidth: "100%", height: "auto" }}
            />
        </div>

        <p className="page-text"><b>Frauenlauf 2022</b></p>
        <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
            <img
                src={frauenlauf2022Img}
                alt="Frauenlauf 2022"
                style={{ maxWidth: "100%", height: "auto" }}
            />
        </div>

        <p className="page-text"><b>Herzlauf 2022</b></p>
        <p className="page-text">
            Herzdoktorteam trifft "Gesund wachsen" Orditeam!<br />
            Mit großer Begeisterung und Enthusiasmus absolvierten die Teams diesen wunderbaren Frühlingslauf durch den blühenden Donaupark.<br />
            Wir hatten sogar unsere treuesten Patienten dabei.<br />
            Unsere „Anja“ hat den dritten Platz erlangt! Wir sind sehr stolz auf sie!<br />
            Schön war's.
        </p>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", margin: "20px 0" }}>
            <img src={herzlauf2022Img1} alt="Herzlauf 2022 - 1" style={{ maxWidth: "100%", height: "auto" }} />
            <img src={herzlauf2022Img2} alt="Herzlauf 2022 - 2" style={{ maxWidth: "100%", height: "auto" }} />
            <img src={herzlauf2022Img3} alt="Herzlauf 2022 - 3" style={{ maxWidth: "100%", height: "auto" }} />
            <img src={herzlauf2022Img4} alt="Herzlauf 2022 - 4" style={{ maxWidth: "100%", height: "auto" }} />
        </div>

        <p className="page-text"><b>Marathon Wien 2022</b></p>
        <p className="page-text">
            Das Herzdoktorteam war wieder dabei!<br />
            Trotz einigen coronabedingten Ausfällen haben wir einen Halbmarathon und eine Marathonstaffel geschafft!
        </p>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", margin: "20px 0" }}>
            <img src={marathon2022Img1} alt="Marathon Wien 2022 - 1" style={{ maxWidth: "100%", height: "auto" }} />
            <img src={marathon2022Img2} alt="Marathon Wien 2022 - 2" style={{ maxWidth: "100%", height: "auto" }} />
        </div>
    </div>,
    <div className="page-container">
        <h1>Kurse – Herzdoktor Laufteam</h1>

        <p className="page-text"><b>Vienna City Marathon am 12.09.2021</b></p>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "start", gap: "20px" }}>
            <img
                src={marathon2021Img}
                alt="Vienna City Marathon 2021"
                style={{ maxWidth: "300px", height: "auto", float: "right" }}
            />
            <p className="page-text" style={{ flex: 1 }}>
                Meine lieben Damen und Herren!<br /><br />
                Der Vienna City Marathon 2021 ist geschafft!<br /><br />
                <b>Danke an unser tolles Team und alle, die mitgefiebert haben!</b><br />
                2 Staffeln, 1 Marathon und ein Halbmarathon erfolgreich absolviert.
            </p>
        </div>

        <p className="page-text"><b>Frauenlauf am 03.10.2021</b></p>
        <p className="page-text"><strong><em>Wie langsam Du auch läufst – Du schlägst alle, die zu Hause bleiben!</em></strong></p>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "start", gap: "20px" }}>
            <img
                src={frauenlauf2021Img}
                alt="Frauenlauf 2021"
                style={{ maxWidth: "300px", height: "auto", float: "right" }}
            />
            <p className="page-text" style={{ flex: 1 }}>
                Meine lieben Damen!<br /><br />
                Der Frauenlauf 2021 ist absolviert!<br />
                Unser Team war wieder erfolgreich unterwegs mit allen Auflagen, die notwendig waren – da wir alle geimpft sind.
            </p>
        </div>

        <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
            <img
                src={herzlogoImg}
                alt="Herzdoktor Logo"
                style={{ maxWidth: "150px", height: "auto" }}
            />
        </div>
        
        <p className="page-text" style={{ textAlign: "center", marginTop: "10px" }}>
            Frische Bewegungsgrüße schickt allen<br />
            Ihre Claudia Sebald und Team!
        </p>
    </div>,

    <div className="page-container">
        <h1>Kurse – Herzdoktor Laufteam</h1>

        <p className="page-text">
            Es ist vollbracht, wir haben den Frauenlauf 2018 wieder erfolgreich bestritten und den heißen Temperaturen getrotzt!
        </p>

        <p className="page-text">
            5km Walken, 5 km Laufen und 10 km Laufen – das Herzdoktor-Team war in allen Disziplinen hervorragend vertreten.<br />
            Danke an alle Teilnehmerinnen und an alle, die mit uns gefiebert und die Daumen gehalten haben.<br />
            Bis zum nächsten Jahr!
        </p>

        <p className="page-text">
            <strong>Wir danken allen fürs Mitmachen oder Daumen halten. Bis zum nächsten Jahr!</strong>
        </p>

        <div className="image-grid">
            <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "20px" }}>
                <img src={frauenlauf2018_1} alt="Frauenlauf 2018 Bild 1" style={{ maxWidth: "45%", height: "auto" }} />
                <img src={frauenlauf2018_2} alt="Frauenlauf 2018 Bild 2" style={{ maxWidth: "45%", height: "auto" }} />
            </div>

            <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "20px" }}>
                <img src={frauenlauf2018_3} alt="Frauenlauf 2018 Bild 3" style={{ maxWidth: "45%", height: "auto" }} />
                <img src={frauenlauf2018_4} alt="Frauenlauf 2018 Bild 4" style={{ maxWidth: "45%", height: "auto" }} />
            </div>

            <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                <img src={frauenlauf2018_5} alt="Frauenlauf 2018 Gruppenbild" style={{ maxWidth: "90%", height: "auto" }} />
            </div>
        </div>
    </div>,

    <div className="page-container">
        <h1>Kurse – Herzdoktor Laufteam</h1>

        <p className="page-text">
            Mit großer Freude hat unser Herzdoktor-Team erstmalig den Frauenlauf 2017 erfolgreich bestritten. 
            Patientinnen, Freunde, Mitarbeiter haben in allen drei Disziplinen (5 km Lauf, 10 km Lauf, 5 km Walking) Spitzen-Ergebnisse erzielt.
        </p>

        <p className="page-text">
            <strong>Wir danken allen fürs Mitmachen oder Daumen halten. Bis zum nächsten Jahr!</strong>
        </p>

        <div className="image-grid">
            <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "20px" }}>
                <img src={frauenlauf2017_1} alt="Frauenlauf 2017 Bild 1" style={{ maxWidth: "45%", height: "auto" }} />
                <img src={frauenlauf2017_2} alt="Frauenlauf 2017 Bild 2" style={{ maxWidth: "45%", height: "auto" }} />
            </div>
            <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "20px" }}>
                <img src={frauenlauf2017_3} alt="Frauenlauf 2017 Bild 3" style={{ maxWidth: "45%", height: "auto" }} />
                <img src={frauenlauf2017_4} alt="Frauenlauf 2017 Bild 4" style={{ maxWidth: "45%", height: "auto" }} />
            </div>
            <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "20px" }}>
                <img src={frauenlauf2017_5} alt="Frauenlauf 2017 Bild 5" style={{ maxWidth: "45%", height: "auto" }} />
                <img src={frauenlauf2017_6} alt="Frauenlauf 2017 Bild 6" style={{ maxWidth: "45%", height: "auto" }} />
            </div>
        </div>
    </div>
]

const Laufteam = () => {
    const { id } = useParams();
    console.log(id);
    return (
        <main>
            <Header image={Banner} />
            <section className="content-section">
                <Navbar />

                {Years[id]}
            </section>
            <Footer />
        </main>
    );
};

export default Laufteam;
